import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '@/hooks/useProducts';
import { useAuthStore } from '@/stores/auth-store';
import { identify, initIntegrations, refreshWidgets } from '@/lib/integrations/storefront-events';

/**
 * Loads connected integrations' storefront scripts (Klaviyo, …) from the
 * public settings payload, identifies the signed-in shopper, and re-renders
 * vendor widgets on SPA navigation. Mounted once in PublicLayout, beside the
 * AXISS widget hook it mirrors.
 */
export function useIntegrationScripts() {
  const { data: settingsData } = useSettings();
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const publicConfig = settingsData?.settings?.integrations_public;

  useEffect(() => {
    initIntegrations(publicConfig);
  }, [publicConfig]);

  useEffect(() => {
    if (!user?.email) return;
    identify({ email: user.email, first_name: (user as any).firstName ?? null, last_name: (user as any).lastName ?? null, id: user.id ?? null });
  }, [user?.email, user?.id, publicConfig]);

  useEffect(() => {
    refreshWidgets();
  }, [location.pathname, publicConfig]);
}
